import { styled } from "@mui/material";
import Grid from "@mui/material/Grid";

const StyledPocFormGrid = styled(Grid)(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  width: '100%',
}));

export default StyledPocFormGrid;